var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M21.14319,7.28182a6.10092,6.10092,0,0,1,4.76269,2.58332,5.87643,5.87643,0,0,0-2.809,4.94791,5.736,5.736,0,0,0,3.48846,5.26013,14.24573,14.24573,0,0,1-1.80017,3.69706c-1.084,1.58649-2.20722,3.16352-3.97892,3.19639-1.74138.03163-2.30267-1.0328-4.29184-1.0328-1.9904,0-2.61361.99993-4.2602,1.06443-1.7104.06509-3.01309-1.71232-4.10469-3.29-2.2325-3.228-3.9391-9.12278-1.6472-13.10108a6.36425,6.36425,0,0,1,5.37772-3.25965c1.68069-.0316,3.26532,1.13017,4.29368,1.13017,1.01262,0,2.82919-1.35455,4.96944-1.19591m-1.32083-2.131A5.7151,5.7151,0,0,0,21.175,1a5.82426,5.82426,0,0,0-3.82974,1.96953,5.44086,5.44086,0,0,0-1.378,4.02129,4.81935,4.81935,0,0,0,3.85508-1.84",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.2022be499f8f0f5a3c894bde1dd65663.svg";
export { ForwardRef as ReactComponent };